<app-modal-refactor
  [size]="'lg'"
  [showImage]="true"
  [image]="'./assets/images/verifyPassport.svg'"
  [isVerPass]="true"
  [showImageClose]="false"
>
  <div body class="authority-restriction-body">
    <span class="authority-restriction-title">{{ titleKey | translate }}</span>
    <span class="authority-restriction-desc">{{ bodyKey | translate }}</span>
    <div class="authority-restriction-actions">
      <button
        type="button"
        class="authority-restriction-btn"
        (click)="onClose()"
      >
        <span>{{ 'authorityRestriction.button' | translate }}</span>
      </button>
    </div>
  </div>
</app-modal-refactor>
